import React from 'react';
import { MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';
import { trackWhatsAppClick } from '../utils/analytics';

const WhatsAppButton = () => {
  const handleClick = () => {
    trackWhatsAppClick('floating_button');
    const url = `https://wa.me/91${contactInfo.whatsappNumber}?text=${encodeURIComponent(contactInfo.whatsappMessage)}`;
    window.open(url, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white p-4 rounded-full shadow-lg shadow-green-500/50 hover:shadow-green-500/70 transition-all duration-300 hover:scale-110 group"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={28} className="animate-pulse" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg">
        Chat with us!
      </span>
    </button>
  );
};

export default WhatsAppButton;
